import { useContext } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import AppRoutes from "./AppRoutes";
import { AuthContext } from "./state/AuthContext";
import { useResetSessionOnNavigation } from "./Hooks/useResetSessionOnNavigation";
import SessionCountdownBadge from "./components/SessionCountdownBadge";

const AppContent = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  // GMA-1909: ONE navigation observer for the whole app. It lives here, inside
  // the Router and mounted for the app's lifetime, rather than in each shell:
  // Layout and WebShell re-mount on every route render, so an observer in them
  // fires on mount and hands out a fresh 30 minutes continuously.
  useResetSessionOnNavigation();

  if (isLoading) {return <div>Loading...</div>;}

  return (
    <>
      <div className="App">
        <div
          className={
            !isAuthenticated || window.location.pathname.includes("/users/")
              ? "App-content-center App-content-bg-custom"
              : "App-content"
          }
        >
          <AppRoutes />
        </div>
      </div>
      {/* GMA-1909: ONE countdown for every authenticated surface. Rendering it
          per shell kept missing surfaces - WebShell first, then /accept-terms
          and the standalone /call route, neither of which renders a shell while
          the provider still expires their session. A single display here cannot
          miss one. */}
      <SessionCountdownBadge />
      <ToastContainer position="top-right" autoClose={5000} theme="light" />
    </>
  );
};

export default AppContent;
